import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "../../../genericEntity/entity/item.css"
import '../../../genericEntity/entity/entity.css'

export const TimeForm = ({ propertyChangeCallback, field, errors, canEdit }) => {
    const [t, i18n] = useTranslation();

    const handleChange = (property, value) => {
        propertyChangeCallback(property, value);
    }

    return (
        <>
            <div className="field-one-columns">
                <div className={`datetime-picker ${!canEdit ? "" : "enabled"}`}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker sx={{ marginTop: "7px" }}
                            slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true } } }}
                            label={t("NgeDefaultValue")}
                            value={field.defaultValue ? dayjs(field.defaultValue) : null}
                            onChange={(e) => handleChange("defaultValue", e)}
                            disabled={!canEdit}
                        />
                    </LocalizationProvider>
                </div>
            </div>
        </>
    )
}
